import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './main/main-index/login/login.component';
import { loginGuard } from './guards/login.guard';
import { ResetPasswordComponent } from './main/main-index/reset-password/reset-password.component';
import { HomeComponent } from './main/main-home/pages/home/home.component';
import { authGuard } from './guards/auth.guard';
import { homeGuard } from './guards/home.guard';
import { ErrorComponent } from './main/main-home/pages/error/error.component';
import { CalendarComponent } from './main/main-home/pages/agenda/calendar/calendar.component';
import { RoomComponent } from './main/main-home/pages/agenda/room/room.component';
import { routeGuard } from './guards/route.guard';
import { ForgotPasswordComponent } from './main/main-index/forgot-password/forgot-password.component';
import { SnSearchComponent } from './main/main-home/pages/lavorazioni/sn-search/sn-search.component';
import { FileViewerPageComponent } from './components/file-viewer/components/file-viewer-page/file-viewer-page.component';
import { PrivacyComponent } from './privacy/privacy/privacy.component';
import { DataDeletionComponent } from './privacy/data-deletion/data-deletion.component';
import { TermsComponent } from './privacy/terms/terms.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
    canActivate: [loginGuard],
  },
  {
    path: '',
    component: HomeComponent,
    // se loggato vai alla home, se non loggato vai a login
    canActivate: [authGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [homeGuard],
    // redirectTo: ''
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  // agenda in futuro se c'è bisogno si crea un modulo e una rotta dentro la cartella agenda
  {
    path: 'agenda/calendar',
    component: CalendarComponent,
    canActivate: [routeGuard],
  },
  {
    path: 'agenda/room',
    component: RoomComponent,
    canActivate: [routeGuard],
  },
  // {
  //   path: 'anagrafica',
  //   loadChildren: () => import('./main/main-home/pages/anagrafica/anagrafica.module').then(m => m.AnagraficaModule)
  // },
  {
    path: 'customer',
    data: { registryType: 'customer' },
    loadChildren: () =>
      import('./main/main-home/pages/customer/customer.module').then(
        (m) => m.CustomerModule,
      ),
  },
  {
    path: 'supplier',
    data: { registryType: 'supplier' },
    loadChildren: () =>
      import('./main/main-home/pages/customer/customer.module').then(
        (m) => m.CustomerModule,
      ),
  },
  {
    path: 'article',
    loadChildren: () => import('./main/main-home/pages/article/article.routes'),
  },
  {
    path: 'ddt',
    loadChildren: () => import('./main/main-home/pages/ddt/ddt.routes'),
  },
  {
    path: 'purchase-order',
    loadChildren: () => import('./main/main-home/pages/purchase-order/purchase-order.routes'),
  },
  {
    path: 'training',
    loadChildren: () =>
      import('./main/main-home/pages/training/training.module').then(
        (m) => m.TrainigsModule,
      ),
  },
  {
    path: 'socivolontari',
    loadChildren: () =>
      import('./main/main-home/pages/soci-volontari/soci-volontari.module').then(
        (m) => m.SociVolontariModule,
      ),
  },
  {
    path: 'lavorazioni/commesse',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/commesse/commesse.module').then(
        (m) => m.CommesseModule,
      ),
  },

  {
    path: 'lavorazioni/rdi',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/rdi/rdi.module').then(
        (m) => m.RdiModule,
      ),
  },
  {
    path: 'lavorazioni/inbound',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/inbound/inbound.routes')
  },
  {
    path: 'lavorazioni/report',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/report/report.module').then(
        (m) => m.ReportModule,
      ),
  },
  {
    path: 'lavorazioni/sn-search',
    component: SnSearchComponent,
    canActivate: [routeGuard],
  },
  {
    path: 'lavorazioni/wp-form',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/wp-form/wp-form.routes'),
  },
  {
    path: 'lavorazioni/inverter',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/inverter/inverter.module').then(
        (m) => m.InverterModule,
      ),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./main/main-home/pages/settings/setting.module').then(
        (m) => m.SettingsModule,
      ),
  },
  {
    path: 'systems',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/systems/systems.module').then(
        (m) => m.SystemsModule,
      ),
  },
  {
    path: 'cabinet',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/cabinet/cabinet.routes'),
  },
  {
    path: 'service-partner',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/service-partner/service-partner.routes'),
  },
  {
    path: 'visit-report',
    loadChildren: () =>
      import('./main/main-home/pages/visit-report/visit-report.module').then(
        (m) => m.VisitReportModule,
      ),
  },
  {
    path: 'weco-jobs',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/jobs/jobs.routes'),
  },
  {
    path: 'weco-departments',
    loadChildren: () =>
      import('./main/main-home/pages/lavorazioni/departments/departments.routes'),
  },
  {
    path: 'prospect',
    loadChildren: () =>
      import('./main/main-home/pages/prospect/prospect.routes'),
  },

  {
    path: 'fm',
    loadChildren: () => import('./main/main-home/pages/fm/fm.routes'),
  },
  {
    path: 'form-test',
    loadChildren: () =>
      import('./main/main-home/pages/form-test/form-test.routes'),
  },
  {
    path: 'ticket',
    loadChildren: () => import('./main/main-home/pages/ticket/ticket.routes'),
  },
  {
    path: 'voucher',
    loadChildren: () => import('./main/main-home/pages/voucher/voucher.routes'),
  },
  {
    path: 'chatbot',
    loadChildren: () =>
      import('./main/main-home/pages/chatbot/chatbot.routes'),
  },
  {
    path: 'chat',
    loadChildren: () =>
      import('./main/main-home/pages/chat/chat.routes'),
  },
  {
    path: 'whatsapp',
    loadChildren: () => import('./main/main-home/pages/whatsapp/whatsapp.routes'),
  },
  {
    path: 'notes',
    loadChildren: () =>
      import('./main/main-home/pages/notes/notes.routes'),
  },
  {
    path: 'subscriptions',
    loadChildren: () => import('./main/main-home/pages/subscriptions/subscription.routes'),
  },
  {
    path: 'payment',
    loadChildren: () => import('./main/main-home/pages/payment/payment.routes'),
  },
  {
    path: 'agent',
    loadChildren: () => import('./main/main-home/pages/agent/agent.routes'),
  },
  // {
  //   path: 'privacy',
  //   component: PrivacyComponent,
  // },
  // {
  //   // non funziona su facebook
  //   path: 'data-deletion',
  //   component: DataDeletionComponent,
  // },
  // {
  //   path: 'terms',
  //   component: TermsComponent,
  // },
  {
    path: 'viewer/:type/:name/:src',
    component: FileViewerPageComponent,
  },
  {
    path: '**', // Intercetta qualsiasi rotta non trovata
    redirectTo: '', // Reindirizza alla rotta principale (path: '')
    pathMatch: 'full', // Obbligatorio per i redirect dal path ''
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
